export const SET_DEBITS = 'SET_DEBITS';
export const CREATE_DEBITS = 'CREATE_DEBITS';
